import React from 'react';
import '../../css/home/Hero.css';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="main-hero-container">
      {/* Background image placeholder */}
      <div className="main-hero-background"></div>
      
      {/* Content adjusted left and higher */}
      <div className="main-hero-content">
        <h1 className="main-hero-heading">Connecting brands<br />to colleges</h1>
        <div className="main-hero-input-container">
          <Link to="/brands"><button className="main-hero-button">Get Started</button></Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;